(function() { window.GUID_5f507b2f_2e3f_47a8_9955_70ea4ee7ddcf = { getGuid: function() { return "5f507b2f-2e3f-47a8-9955-70ea4ee7ddcf"; } }; })();
var Menu;
(function (Menu) {
    Menu.csMainMenuButton = $('#CSMainMenuButton');
    Menu.csMainMenuIcon = $('.Icon', Menu.csMainMenuButton);
    Menu.mainMenu = $('#MainMenu');
    var headers = $('.MenuPath>.MenuItemsHeader', Menu.mainMenu);
    var highlightedMenu = $('.IsHighlighted', Menu.mainMenu);
    Menu.masterContainer = $('#MasterContainer');
    Menu.toolBarContainer = $('#ToolBarContainer');
    Menu.preventHideMenu = false;
    Menu.mainMenu.on('mousedown', function (e) {
        // Ne pas arreter la propagation si on enregistre des tutoriels
        // if (typeof (isRecordingTutorial) == "undefined" || isRecordingTutorial != true) {
        e.stopPropagation();
        // }
    });
    headers.on('click', function (e) {
        var header = $(this);
        var parent = header.parent();
        var openCloseButton = $('>.PlusMinus', header);
        var menuItems = $('>.MenuItems', parent);
        var state = '';
        if (menuItems.is(":visible")) {
            menuItems.slideUp(250, function () {
                openCloseButton.html("+");
            });
            state = 'IsClosed';
        }
        else {
            menuItems.slideDown(250, function () {
                openCloseButton.html("-");
            });
            state = 'IsOpened';
        }
        CallKeepMenuState(parent[0].id, state);
    });
    function ExpandMenuHeader(header) {
        var parent = header.parent();
        var openCloseButton = $('>.PlusMinus', header);
        var menuItems = $('>.MenuItems', parent);
        var state = '';
        if (!menuItems.is(":visible")) {
            menuItems.slideDown(250, function () {
                openCloseButton.html("-");
            });
            state = 'IsOpened';
        }
        CallKeepMenuState(parent[0].id, state);
    }
    Menu.csMainMenuButton.on('click', function (e) {
        e.stopPropagation();
        if (IsDefined(typeof (ShowHideMenu))) {
            if (Menu.mainMenu.css('display') == "none") {
                ShowHideMenu(true);
            }
            else {
                ShowHideMenu(false);
            }
        }
    });
    /*window.onblur = function () {
        ShowHideMenu(false);
    };*/
    function ShowHideMenu(show) {
        if (IsDefined(typeof (Menu.desktop))) {
            Menu.desktop.ShowHideMenu(show);
        }
    }
    Menu.ShowHideMenu = ShowHideMenu;
    //function ShowHideMenu(show) {
    //    if (show || (mainMenu.is(':visible') && show == false)) {
    //        //CallKeepMenuState("MainMenu", show ? 'IsOpened' : 'IsClosed');
    //        if (show) {
    //            //if (!(typeof silverlightCtl === "undefined") && silverlightCtl != null)
    //            //masterContainer.animate({ 'left': '13.5em' }, 250);
    //            //toolBarContainer.animate({ 'left': '0' }, 250);
    //            mainMenu.show("slide", { direction: "left" }, 250, function () {
    //                csMainMenuButton.addClass('IsOpened');
    //            });
    //            CS.trigger("menuShow");
    //        } else {
    //            //if (!(typeof silverlightCtl === "undefined") && silverlightCtl != null)
    //            //masterContainer.animate({ 'left': '0' }, 250);
    //            //toolBarContainer.animate({ 'left': '120px' }, 250);
    //            toolBarContainer.show();
    //            mainMenu.hide("slide", { direction: "left" }, 250, function () {
    //                csMainMenuButton.removeClass('IsOpened');
    //            });
    //        }
    //    }
    //}
    function CallKeepMenuState(id, state) {
        if (CSParameters.IsConnected) {
            var data = {
                keyName: id,
                value: state,
                noSportEventId: true,
                controllerName: "CSBaseController"
            };
            CompuSport.Ajax.Post(CSParameters.BaseUrl + 'Global/SaveUserData/' + CSParameters.SportEventId, data, function () {
            });
        }
    }
    //TEST, doit etre flusher
    $('#SubMenu23').on('click', function (e) {
        e.preventDefault();
    });
    //var mainMenuScroll = GetCookieValue(CSParameters.SportEventId, "MainMenuScroll");
    //if (mainMenuScroll != null) {
    //    mainMenu.scrollTop(mainMenuScroll);
    //}
    CS.doc.on('mousedown.mainmenu', function () {
        if (Menu.preventHideMenu) {
            return;
        }
        if (IsDefined(typeof (ShowHideMenu))) {
            ShowHideMenu(false);
        }
    });
    var csMainMenuButtonStartPosition = null;
    var mainMenuStartPosition = null;
    function PushMenuDownForHintMessage(hintHeight) {
        if (csMainMenuButtonStartPosition == null) {
            csMainMenuButtonStartPosition = Menu.csMainMenuButton.css('top');
            if (csMainMenuButtonStartPosition != null) {
                csMainMenuButtonStartPosition = parseFloat(csMainMenuButtonStartPosition.replace("px", ""));
            }
            else {
                csMainMenuButtonStartPosition = 0;
            }
        }
        if (mainMenuStartPosition == null) {
            mainMenuStartPosition = Menu.mainMenu.css('top');
            if (mainMenuStartPosition != null) {
                mainMenuStartPosition = parseFloat(mainMenuStartPosition.replace("px", ""));
            }
            else {
                mainMenuStartPosition = 0;
            }
        }
        Menu.csMainMenuButton.animate({ 'top': csMainMenuButtonStartPosition + hintHeight + 10 }, 300);
        Menu.mainMenu.animate({ 'top': mainMenuStartPosition + hintHeight + 10 }, 300);
    }
    Menu.PushMenuDownForHintMessage = PushMenuDownForHintMessage;
    function PullMenuUpForHintMessage() {
        Menu.csMainMenuButton.animate({ 'top': csMainMenuButtonStartPosition }, 300);
        Menu.mainMenu.animate({ 'top': mainMenuStartPosition }, 300);
    }
    Menu.PullMenuUpForHintMessage = PullMenuUpForHintMessage;
})(Menu || (Menu = {}));

//# sourceMappingURL=Menu.js.map
